<template>
    <div class="fixed-page">
        <div class="sub-tit">
            <h2>주차</h2>
        </div>
        <div class="tab-menu type02">
            <ul class="tab-menu__list">
                <li class="tab-menu__item on"><a href="/park/parkIntro.do" type="button" class="tab-menu__btn">창원파티마병원 주차등록</a></li>
            </ul>
        </div>
        <div class="parkingRes_wrap">
            <div class="join-tab">
                <ul class="join-tab__list">
                    <li class="join-tab__item active">
                        <div class="tit">창원파티마 차량조회</div>
                    </li>
                </ul>
            </div>

            <div class="certification">
                <ul class="contents login-box__list">
                    <li class="login-box__item">
                        <div class="icon">
                            <img src="@/assets/resource/icon/logo-b.png" alt="로고">
                        </div>
                        <h3 class="tit">차량조회</h3>
                        <p class="desc">조회하기 버튼을 누르시면 차량조회 페이지로 넘어갑니다.</p>
                        <div class="btn-wrap center">
                            <a href="/park/parkForm.do" class="btn blue">
                                <span>조회하기</span>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import LocationBar from '@/components/common/LocationBar.vue'

export default {
    components: {
        LocationBar,
    },
    data() {
       
    },
    mounted() {
       
    },
    beforeUnmount() {
       
    },
    methods: {
       
    },
}
</script>